/*
Monotype Foundry Platform API
Version 1.0.0

Definition: QuarterlyReportsProjectRequest

Properties:
  year: number (required)
  quarter: string (required)
*/

var QuarterlyReportsProjectRequest = (function () {
  function validateQuarterlyReportsProjectRequest (arg) {
    // Validate year
    if (!arg.year) {
      throw new Error('QuarterlyReportsProjectRequest.year: Missing property')
    }
    if (arg.year && !(typeof arg.year === 'number')) {
      throw new Error('QuarterlyReportsProjectRequest.year: Wrong type: Got \'' + (typeof arg.year) + '\', but expected: \'number\'')
    }
    // Validate quarter
    if (!arg.quarter) {
      throw new Error('QuarterlyReportsProjectRequest.quarter: Missing property')
    }
    if (arg.quarter && !(typeof arg.quarter === 'string')) {
      throw new Error('QuarterlyReportsProjectRequest.quarter: Wrong type: Got \'' + (typeof arg.quarter) + '\', but expected: \'string\'')
    }
  }
  function buildQuarterlyReportsProjectRequest (arg) {
    var QuarterlyReportsProjectRequest = arg
    // Complete year
    // Expected Type: number
    QuarterlyReportsProjectRequest.year = QuarterlyReportsProjectRequest.year || 0
    // Complete quarter
    // Expected Type: string
    QuarterlyReportsProjectRequest.quarter = QuarterlyReportsProjectRequest.quarter || ''
    return QuarterlyReportsProjectRequest
  }
  return {
    validate: validateQuarterlyReportsProjectRequest,
    build: buildQuarterlyReportsProjectRequest
  }
})()

module.exports = QuarterlyReportsProjectRequest
